import React, { useState, useEffect } from "react";
import Headings from "@project-stories/elements/Headings/Headings";
import { Paragraph } from "@arctheme-components/elements/Paragraph/Paragraph";
import { ProductTile } from "@project-stories/ecommerce/Product/ProductTile";
import ListProductsCTA from "../ListProductsCTA/ListProductsCTA";
import useMobileBreakpoint from "@src/hooks/useMobileBreakpoint";
import useColoredTextParser from "@project-stories/../hooks/useColoredTextParser"; // adjust path as needed
import { DosagePopup } from "../DosagePopup"
import { SubscribePopup } from "../SubscribePopup";
import { SecondaryCTA } from "../ListProducts";

export default function ListProductsGrid({ products, settings }) {
  const { section, mobile_breakpoint, product_limit } = settings;
  const isMobile = useMobileBreakpoint(mobile_breakpoint);

  // Move hook usage and derived values above any conditional returns
  const renderFormattedTitle = useColoredTextParser({
    title: section?.title,
    accentTitleParts: section?.accent_title_parts,
    accentColor: section?.accent_color,
    headerStyle: section?.header_style,
    seoStyle: section?.seo_title_font_type,
    HeadingsComponent: Headings,
  });

  let ctaPosition = isMobile ? "bottom" : "top";

  settings.show_price = section.product_tile_price_show;
  settings.show_quickadd = section.product_tile_quickadd_show;
  settings.show_tags = section.product_tile_tag_show;

  // Apply product limit if set
  const limitedProducts = product_limit > 0 ? products.slice(0, product_limit) : products;
  
  const [isDosageOpen, setIsDosageOpen] = useState(false);
  const [isSubscribeOpen, setIsSubscribeOpen] = useState(false);
  const [dosageGuide, setDosageGuide] = useState(false);
  const [subscriptionItem, setSubscriptionItem] = useState(false);


  const onClickDosage = (productItem) => {
    const dosage = productItem?.dosage || productItem?.dosage_form;
    if(dosage) {
      setDosageGuide(productItem);
      setIsDosageOpen(true);
    }
  };

  const onClickSubscribe = (productItem) => {
    if(productItem) {
      setSubscriptionItem(productItem);
      setIsSubscribeOpen(true);
  };
}

  const secondaryCTA = section.secondary_cta_type || SecondaryCTA.DOSAGE;

  if (limitedProducts.length <= 0) {
    return false;
  }

  return (
    <div className="product-list">
     <div className={"section-top max-w-[335px] lg:max-w-[384px] mx-auto text-center mb-[32px]"}>
        <div className={"section-bar w-full flex flex-row justify-center"}>
          <div className={"section-info"}>
            {section?.title && renderFormattedTitle()}
            <Paragraph text={section?.subtext} type={section?.subtext_style} />
          </div>
          {ctaPosition === "top" && (
            <ListProductsCTA section={section} isMobile={isMobile} />
          )}
        </div>
      </div>

      <div className={"w-full "}>
        <div className="row-start-1 col-start-1">
          <div className="carousel-item-container w-full">
            <div className="product-list__grid grid grid-cols-2 lg:grid-cols-3 gap-[8px] lg:gap-[24px] w-full">
              {limitedProducts.map((product, id) => (
                <div key={id} className="grid-item">
                  <ProductTile
                    product={product}
                    swatches={product?.swatches}
                    siblings={undefined}
                    settings={settings}
                    enableWishlist={section.product_tile_wishlist_show}
                    onClickDosage={() => onClickDosage(product)}
                    onClickSubscribe={() => onClickSubscribe(product)}
                     showDosageButton={secondaryCTA == SecondaryCTA.DOSAGE && ( product?.dosage  || product.dosage_form )}
                    showSubscribeButton={secondaryCTA == SecondaryCTA.SUBSCRIBE}
                    noSecondaryButton={secondaryCTA == SecondaryCTA.NONE}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className={"section-bottom flex justify-center mt-4"}>
        {ctaPosition === "bottom" && (
          <ListProductsCTA section={section} isMobile={isMobile} />
        )}
      </div>
      <DosagePopup isOpen={isDosageOpen} setIsOpen={setIsDosageOpen} product={dosageGuide} settings={settings} />
      <SubscribePopup isOpen={ isSubscribeOpen} setIsOpen={setIsSubscribeOpen} product={subscriptionItem} settings={settings} translations={settings.translations}/>
    </div>
  );
}
